/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import { getPopupConfig } from '../../components/Popup';
import constants from '../../globalization';
import View from './views';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import CommonUtil from '../Fireboard/common';
import { getPickerData } from "../../components/CountryPicker";
import UTILLib from "../../util";
import EventEmitter from '../../util/event-emitter';
import { LogLevelEnum, NotificationType, checkEnum } from '../../enums';
import { retryPOSPayment } from "../../store/actions";
import modeEnums from '../../enums/modeEnums';
import { TimeConstants } from '../../constants';
import MenuUtils from '../../util/menu-utils';
import { updateNotification } from '../../store/actions/notification';
import { acknowledgeNoticationAction } from "../../store/actions/notifications";
import { version } from '../../../package.json';

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

const POPUPS_ENUMS = {
  SMS: "sms",
  GENERATE_QR: "generate-qr",
  MEMBER_DETAILS: "member-details",
  GENERATE_QR_JOIN_CHECK: "generate-qr-join-check",
  CHECK_ACTIONS: "check-actions",
  RE_POST_PAYMENT: "repostpayment",
  VIEW_ON_MAP: "viewOnMap",
  REDEEM_CHECK_VOUCHER: "redeemCheckVoucher",
  UPDATE_GUEST_INFO: "updateGuestInformation",
};

class TableDelivery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      isCustomSmsType: true,
      customSmsList: [],
      selectedCountry: {},
      selectedCheck: {},
      sensorData: {},
      isDevEnvironment: false,
      fromFooter: false,
      checkList: [],
      items: [],
      pendingItems: [],
      twoDimensionSlot: [[]],
      sortByName: true,
      ascending: true,
      showNotifications: false,
      notificationControlEnabled: false,
      snoozeEnabled: false,
      managerMode: false,
      notificationTypes: [],
    };
    this.checks = new Map();
    this.currency = this.props?.reduxProps?.currencyInfo?.currency || '$';
    this.countriesData = [];
    this.parentRoute = '';
    this.notifyOrderPrepared = {};
    this.notifyOrderReady = {};
    this.filteredChecks = [];
    this.activeCheckFilter = 'sourceType';
    this.checkSourceTypes = [];
    this.checkOrderTypes = [];
    this.checkRevenueTypes = [];
    this.checkSensorGroupTypes = [];
    this.notificationSourceTypes = [];
    this.notificationOrderTypes = [];
    this.notificationRevenueTypes = [];
    this.notificationSensorGroupTypes = [];
    this.cubbyLayoutPopupType = '';
    this.storeCubbySlotsMap = new Map();
    this.currentMode = modeEnums.TABLE_DELIVERY;
    this.checkIdsMap = new Map();
    this.snoozeTimeInterval = null;
    this.seatId = null;
    this.sensorsMap = new Map();
    this.enableAgeRestrictedOrderingForCheck = false;
    this.enableAgeRestrictedOrderingForSeat = false;
    this.enableAgeVerification = false;
    this.ageRestrictedItemsForSeat = {};
  }

  componentDidMount() {
    const { reduxProps, history } = this.props;
    const { storeInfo, deviceInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting Fireboard component in Table Delivery mode with storeId ${storeId} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }

    this.getCustomSmsTemplates();

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.state.isDevEnvironment = true;
    }

    const { location } = history || {};
    const { state } = location || {};
    const { parentRoute, mode } = state || {};
    this.parentRoute = parentRoute;
    this.currentMode = mode || modeEnums.TABLE_DELIVERY;

    //In Table Delivery Mode:- set default filters to sort by time and descending order
    if (mode === modeEnums.TABLE_DELIVERY) {
      this.state.sortByName = false;
      this.state.ascending = false;
    }

    this.countriesData = getPickerData();
    const countryCode = this.currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    this.state.selectedCountry = this.countriesData.find(country => country.iso2 === countryCode);

    this.buildSensorsHashTable();
    this.setDeviceGroupData();

    const { context } = this.props;
    this.setChecks(context?.checks);

    this.startInterval();

    if (window.ReactNativeWebView) {
      this.scanToRedeemListener = message => this.onVoucherScanned(message);
      EventEmitter.addListeners('onVoucherScanned', this.scanToRedeemListener);
    }
  }

  componentWillUnmount() {
    if (window.ReactNativeWebView) {
      this.scanToRedeemListener && EventEmitter.removeListeners('onVoucherScanned', this.scanToRedeemListener);
    }
    this.stopInterval();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps } = newProps;
    this.handleRetryPOSPayment(reduxProps);

    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      this.setChecks(nextContext?.checks, nextContext?.deletedChecks);
      if (nextContext?.newNotifications && nextContext.newNotifications.length) {
        this.handleNewNotification(nextContext.newNotifications);
      }
    }

    //auto close notification screen once all notifications have been dismissed
    if (this.props.reduxProps?.notifications !== reduxProps?.notifications) {
      const { notifications } = reduxProps;
      const notificationCount = Array.isArray(notifications) ? notifications.length : 0;
      if (notificationCount === 0) {
        this.setState({ showNotifications: false });
      }
    }
  }

  setChecks = (checks, deletedChecks) => {
    let checksMap = new Map();
    const allChecks = Array.from(checks.values());
    allChecks && allChecks.forEach(check => {
      checksMap.set(check.id, CommonUtil.parseCheckFromRedis(check));
    });
    this.checks = checksMap;
    this.refreshChecks();
  };

  setDeviceGroupData = () => {
    const { reduxProps: { deviceApi, deviceApiData, storeInfo } } = this.props;
    const { managerMode } = this.state;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    const { notificationTypes: nTypes } = storeInfo?.data || {};
    let updatedNotificationTypes = nTypes.filter(n => n.id !== 16 && n.id !== 19 && n.id !== 20);
    if (!managerMode) {
      updatedNotificationTypes = updatedNotificationTypes.filter(type => type.id !== 14 && type.id !== 15);
    }
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const {
        fireBoardSettings,
        checkChannelFilters,
        checkOrderTypeFilters,
        checkRevenueCenterFilters,
        checkSensorGroupFilters,
        notificationChannelFilters,
        notificationOrderTypeFilters,
        notificationRevenueCenterFilters,
        notificationTypeFilters,
        notificationSensorGroupFilters,
      } = deviceGroup || {};
      this.activeCheckFilter = CommonUtil.getActiveFilterSourceFromDeviceGroup(fireBoardSettings);
      this.checkSourceTypes = CommonUtil.getODOrderTypes(checkChannelFilters);
      this.checkOrderTypes = CommonUtil.getPOSOrderTypes(checkOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.checkRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(checkRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.checkSensorGroupTypes = CommonUtil.getSensorGroupOrderTypes(checkSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.notificationSourceTypes = CommonUtil.getODOrderTypes(notificationChannelFilters);
      this.notificationOrderTypes = CommonUtil.getPOSOrderTypes(notificationOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.notificationRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(notificationRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.notificationSensorGroupTypes = []; //CommonUtil.getSensorGroupOrderTypes(notificationSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.state.notificationTypes = CommonUtil.getNotificationTypeNameFromDeviceGrp(notificationTypeFilters, updatedNotificationTypes);
      this.enableAgeRestrictedOrderingForCheck = fireBoardSettings?.enableAgeRestrictedOrderingForCheck || false;
      this.enableAgeRestrictedOrderingForSeat = fireBoardSettings?.enableAgeRestrictedOrderingForSeat || false;
      this.enableAgeVerification = fireBoardSettings?.enableAgeVerification || false;
    } else {
      const { reduxProps } = this.props;
      const { storeTypesPersist, notificationsTypesPersist } = reduxProps;
      const { activeCheckFilter, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes, notificationTypes } = storeTypesPersist?.data || {};
      const { sourceType: nSourceType, orderType: nOrderType, revenueCenter: nRevenueCenter, sensorGrpTypes: nSensorGrpTypes } = notificationsTypesPersist?.data || {};
      this.activeCheckFilter = activeCheckFilter || 'sourceType';
      this.checkSourceTypes = sourceTypes || [];
      this.checkOrderTypes = orderTypes || [];
      this.checkRevenueTypes = revenueTypes || [];
      this.checkSensorGroupTypes = sensorGrpTypes || [];
      this.notificationSourceTypes = nSourceType || [];
      this.notificationOrderTypes = nOrderType || [];
      this.notificationRevenueTypes = nRevenueCenter || [];
      this.notificationSensorGroupTypes = []; //nSensorGrpTypes || [];
      this.state.notificationTypes = notificationTypes || [];
    }
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data.message
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading)
      popup.heading = heading;
    if (message)
      popup.message = message;
    this.setState({ popup });
  };

  showPopup = (type, data) => {
    switch (type) {
      case POPUPS_ENUMS.CHECK_ACTIONS:
        const check = data || {};
        this.state.popup = { type };
        this.onSelectCheck(check);
        break;
      case POPUPS_ENUMS.SMS:
      case POPUPS_ENUMS.RE_POST_PAYMENT:
      case POPUPS_ENUMS.REDEEM_CHECK_VOUCHER:
      case POPUPS_ENUMS.VIEW_ON_MAP:
      case POPUPS_ENUMS.UPDATE_GUEST_INFO:
        this.setState({ popup: { type } });
        break;
      default:
        console.warn(`popup type - ${type} not handled!!!`);
        break;
    }
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  goBack = () => {
    const { history } = this.props;
    history && history.push('/fireboard');
  };

  startInterval = () => {
    this.stopInterval();
    this.interval = setInterval(() => {
      this.refreshChecks();
    }, 60 * 1000);
  };

  stopInterval = () => {
    this.interval && clearInterval(this.interval);
    this.interval = null;
  };

  getFilteredChecks = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const checks = Array.from(this.checks.values());
    const filters = {
      data: {
        orderTypes: this.checkOrderTypes,
        sourceTypes: this.checkSourceTypes,
        revenueTypes: this.checkRevenueTypes,
        sensorGroupTypes: this.checkSensorGroupTypes,
        activeCheckFilter: this.activeCheckFilter,
      }
    };
    let filteredCheckList = CommonUtil.getAllSelectedChecks(checks, filters, storeInfo, this.sensorsMap);
    if (this.currentMode === modeEnums.TABLE_DELIVERY) {
      // should not display voided checks
      filteredCheckList = filteredCheckList.filter(check => {
        const { orders } = check;
        const [order0] = orders || [];
        if (check?.void === true || orders?.length === 0 || order0?.status === 10 || order0?.orderStatusId === 5)
          return false;
        return true;
      });
    } else if (this.currentMode === modeEnums.GPS_LOCATION) {
      filteredCheckList = filteredCheckList.filter(check => {
        const { orders } = check || {};
        const [order0] = orders || [];
        const { pickUpStatus } = order0 || {};
        return pickUpStatus === 0 && check.orderStatusId !== 10;
      });
    }
    return filteredCheckList;
  };

  refreshChecks = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { storeCubby } = storeInfo?.data || {};
    this.storeCubbySlotsMap = FireboardUtils.buildStoreCubbyHashTable(storeCubby);
    this.filteredChecks = this.getFilteredChecks();
    const checks = this.getFormattedChecks;
    const twoDimensionSlot = FireboardUtils.getCubbySlotsData(storeCubby, checks);

    //if check is already selected - update selectedCheck, items & pendingItems
    let { selectedCheck } = this.state;
    let items = [];
    let pendingItems = [];
    if (selectedCheck && Object.keys(selectedCheck).length !== 0 && selectedCheck.constructor === Object) {
      selectedCheck = checks.find(check => check?.id === selectedCheck?.id) || {};
      items = selectedCheck?.items || [];
      const isPOSOrder = CommonUtil.getOrderTypeFromSourceType(selectedCheck?.sourceType) === constants.orderType_POS;
      if (isPOSOrder) {
        items = FireboardUtils.updatePOSItems(selectedCheck);
        const pendingCheckItems = MenuUtils.getPendingItemsFromCheck(selectedCheck);
        pendingItems = FireboardUtils.updatePendingPOSItems(pendingCheckItems, selectedCheck);
      }

      this.filterOrdersWithSameTblNum(selectedCheck);
    }

    this.setState({
      checkList: checks,
      twoDimensionSlot,
      selectedCheck,
      items,
      pendingItems,
    });
  };

  get getFormattedChecks() {
    const formattedChecks = this.filteredChecks.map(check => this.formatCheck(check));
    return formattedChecks || [];
  };

  formatCheck = check => {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};
    const [order0] = check?.orders || [];
    const { sendDate, pickupDate, orderDate, storeCubbySlotId } = order0 || {};
    const { color, elapsedTimeToDisplay, elapsedTimeInMS } = this.getElapsedTime(check);
    const slot = this.storeCubbySlotsMap.has(storeCubbySlotId) ? this.storeCubbySlotsMap.get(storeCubbySlotId) : {};
    const slotName = slot?.name || '';
    const { locationElapsedTimeInMinTxt, locationRefButtonColor } = this.getLocationElapsedTime(order0?.lastLocationUpdateDate);
    const { paidIcon, preAuthIcon } = FireboardUtils.getPaidStatusIcon(check, this.currency);
    return {
      selectedCheckDetails: check,
      checkNumber: check.checkNumber,
      number: check.number,
      id: check.id,
      checkHeaderId: check.checkHeaderId,
      deliverTo: FireboardUtils.getDeliverTo(check),
      sourceType: check.sourceType,
      phoneNumber: check.phoneNumber ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2) : "- -",
      unFormattedPhoneNumber: check.phoneNumber,
      orderStatusId: check.orderStatusId,
      pickupDate: pickupDate,
      orderDate: orderDate,
      openDate: check.openDate,
      orders: check.orders,
      orderTypeId: check.orderTypeId,
      checkName: check.name,
      tabName: check.tabName,
      checkInNote: check.checkInNote,
      unpaidAmount: check.unpaidAmount,
      paidAmount: check.paidAmount,
      open: check.open,
      stationId: check.stationId,
      referenceId: check.referenceId,
      taxAmount: check.taxAmount,
      subTotalAmount: check.subTotalAmount,
      totalAmount: check.totalAmount,
      guestName: check.guestName,
      items: check.items,
      tickets: check.tickets,
      seats: check.seats,
      stationName: check.stationName,
      businessDate: check.businessDate,
      vouchers: check.vouchers,
      revenueCenterId: check.revenueCenterId,
      closeDate: check.closeDate,
      void: check.void,
      employeeFirstName: check.employeeFirstName,
      employeeLastName: check.employeeLastName,
      sendDate: sendDate,
      color: color,
      elapsedTimeToDisplay: elapsedTimeToDisplay,
      elapsedTimeInMS: elapsedTimeInMS,
      slotName: slotName,
      locationUpdateElapsedTime: locationElapsedTimeInMinTxt,
      locationRefreshButtonColor: locationRefButtonColor,
      paidStatusIcon: preAuthIcon || paidIcon,
      tblDeliveryName: this.getTableDeliveryName(check),
    };
  };

  getElapsedTime = check => {
    let color = 'white';
    let elapsedTimeToDisplay = '- -';
    let elapsedTimeInMS = 0;
    if (this.currentMode === modeEnums.TABLE_DELIVERY) {
      const { reduxProps: { deviceApi, deviceApiData } } = this.props;
      const { deviceGroup } = deviceApi?.data || deviceApiData || {};
      const { closeDate } = check || {};
      elapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(closeDate);
      elapsedTimeToDisplay = FireboardUtils.convertElapsedTimeToDisplayTime(elapsedTimeInMS);
      if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
        const { tableDeliveryWarningTime, tableDeliveryErrorTime } = deviceGroup || {}; //error & warning are in seconds
        const elapsedTimeInSec = elapsedTimeInMS / TimeConstants.SECOND;
        if (
          tableDeliveryErrorTime &&
          tableDeliveryErrorTime !== 0 &&
          elapsedTimeInSec > tableDeliveryErrorTime
        ) {
          color = 'red';
        } else if (
          tableDeliveryWarningTime &&
          tableDeliveryWarningTime !== 0 &&
          elapsedTimeInSec > tableDeliveryWarningTime
        ) {
          color = 'orange';
        }
      }
    } else if (this.currentMode === modeEnums.GPS_LOCATION) {
      const dueDate = check.pickupDate || check.orderDate || check.openDate;
      elapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(dueDate);
      elapsedTimeToDisplay = FireboardUtils.convertElapsedTimeToDisplayTime(elapsedTimeInMS);
      // color = (!elapsedTimeInMS || elapsedTimeInMS < 0) ? 'green' : 'red';
    }
    return { color, elapsedTimeToDisplay, elapsedTimeInMS };
  };

  getLocationElapsedTime = (refTime) => {
    const locationElapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(refTime);
    const locationElapsedTimeInMin = locationElapsedTimeInMS / TimeConstants.MINUTE;
    const locationElapsedTimeInMinTxt = FireboardUtils.convertElapsedTimeToDisplayTime(locationElapsedTimeInMS);
    let locationRefButtonColor = 'red';
    if (locationElapsedTimeInMin <= 3)
      locationRefButtonColor = 'green';
    else if (locationElapsedTimeInMin > 3 && locationElapsedTimeInMin <= 6)
      locationRefButtonColor = 'orange';
    else if (locationElapsedTimeInMin > 6)
      locationRefButtonColor = 'red';
    return { locationElapsedTimeInMinTxt, locationRefButtonColor };
  };

  getTableDeliveryName = (check) => {
    const { tabName, name: checkName } = check || {};
    let name = checkName ? checkName : '';
    if (tabName && tabName !== name)
      name = `${name}\n${tabName}`;
    return name;
  };

  onChangeSmsType = () => {
    this.setState(prevState => ({
      isCustomSmsType: !prevState.isCustomSmsType,
    }));
  };

  getCustomSmsTemplates = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    API.getCustomSmsTemplates(storeId)
      .then(response => {
        let { isCustomSmsType, customSmsList } = this.state;
        isCustomSmsType = (response.data && response.data.length > 0) ? true : false;
        customSmsList = response.data || [];
        if (customSmsList && customSmsList.length > 0) {
          this.notifyOrderPrepared = customSmsList.find(each => each.smsTemplate?.smsType === 110) || {};
          this.notifyOrderReady = customSmsList.find(each => each.smsTemplate?.smsType === 112) || {};
        }
        this.setState({ isCustomSmsType, customSmsList });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onHandleSend = (msg, customSmsObj) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, currencyInfo: { iso2 } } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck, selectedCountry, isCustomSmsType } = this.state;
    const callback = () => {
      this.getPopup('spinner', constants.smdSendLoaderHeading, null);
      const { latitude, longitude } = UTILLib.location;
      let payload = {
        latitude,
        longitude,
        deviceId: deviceId,
        storeId: storeInfo?.data?.id,
        phoneNumber: selectedCheck?.unFormattedPhoneNumber || null,
        countryCode: selectedCountry.dialCode.split('+')[1],
        message: msg,
        checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
      };
      if (isCustomSmsType) {
        payload = {
          ...payload,
          custom: true,
          templateId: customSmsObj?.id,
        };
      }
      if (this.seatId) {
        payload['seatId'] = this.seatId;
        this.seatId = null;
      }
      API.fireboardSendSMS(payload)
        .then((resp) => {
          this.closePopup();
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => this.handleErrorPopup(error));
    };
    const popup = getPopupConfig("error");
    popup.heading = constants.confirmationMessage;
    const phoneNumberForSMS = FireboardUtils.formattedPhoneNumber(selectedCheck?.phoneNumber || '', iso2);
    popup.message = constants.sendSmsPopupMsg;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  updateOrderStatus = (item, type) => {
    let delivery = false;
    let deliveryVendorName = '';
    let held = false;
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
      held = item.orders[0].held || false;
    }
    let orderStatusId;
    if (type === "done") {
      // TODO: add enums
      orderStatusId = 5;
      this.dispatchOrderStatus(item, orderStatusId);
    } else if (type === "cancel") {
      const popup = getPopupConfig("success");
      popup.heading = constants.orderCancellation;
      popup.message = held
        ? delivery
          ? 'This action will cancel the order immediately. The order delivery will also be canceled at ' + deliveryVendorName + '. If applicable, the order will not be sent to the POS. This action cannot be reversed. Do you want to continue?'
          : constants.cancelHeldOrderMsg
        : delivery
          ? 'Are you sure you want to cancel the order ? This action will ONLY cancel from the Fireboard and ' + deliveryVendorName + '. This action will NOT cancel from the POS and NOT process a refund.'
          : constants.cancelCheckHeadingAlt;
      popup.buttons = [
        {
          text: constants.no,
          onClick: () => {
            this.setState({ popup: undefined });
          },
        },
        {
          text: constants.yes,
          onClick: () => {
            this.cancelOrder(item);
          },
        },
      ];
      this.setState({ popup });
    } else if (type === "moveToInprogress") {
      const popup = getPopupConfig("error");
      popup.heading = constants.futureToIPHeader;
      popup.message = held ? constants.moveHeldOrderMsg : constants.futureToIPMessage;
      popup.buttons = [
        {
          text: constants.noCaps,
          onClick: () => this.setState({ popup: undefined }),
        },
        {
          text: constants.yesCaps,
          onClick: () => {
            orderStatusId = 1;
            this.dispatchOrderStatus(item, orderStatusId);
          },
        },
      ];
      this.setState({ popup });
    }
  };

  cancelOrder = (item) => {
    const orderStatusId = 8;
    this.dispatchOrderStatus(item, orderStatusId, true);
  };

  dispatchOrderStatus = (item, orderStatusId, isCancel) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    let delivery = false;
    let deliveryVendorName = '';
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
    }
    API.orderStatusUpdate({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
      orderStatusId,
    })
      .then((response) => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        if (isCancel) {
          const popup = getPopupConfig("success", () => {
            this.closePopup();
          });
          popup.heading = constants.cancelSuccess;
          popup.message = delivery
            ? 'Order has been cancelled from the Fireboard and ' + deliveryVendorName + '. Please make sure to cancel it on the POS and process a refund from the portal (if applicable)'
            : constants.cancelSuccessMsg;
          this.setState({ popup });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  markItemAsPaid = item => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusPaid({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
    })
      .then((response) => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  notifyOrderStatus = (type) => {
    const { selectedCheck, selectedCountry } = this.state;
    const { checkHeaderId, id, phoneNumber } = selectedCheck;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id: storeId } = storeInfo?.data || {};
    this.getPopup("spinner", type === 'orderBeingPrepared' ? constants.notifyOrderBeingPrepared : constants.notifyOrderReady, null);
    let templateId = type === 'orderBeingPrepared' ? this.notifyOrderPrepared?.id : this.notifyOrderReady?.id;
    const { latitude, longitude } = UTILLib.location;
    let payload = {
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeId,
      phoneNumber: phoneNumber || "",
      countryCode: selectedCountry.dialCode.split('+')[1],
      custom: true,
      templateId: templateId,
      checkHeaderId: checkHeaderId || id,
    };
    API.fireboardSendSMS(payload)
      .then((resp) => {
        this.closePopup();
        FireboardUtils.addNetworkLogs(resp);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  joinCheck = item => {
    const { sensorData } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { stationId } = item || {};
    this.getPopup('spinner', 'Generating QR', null);
    if (sensorData && sensorData.externalId) {
      this.setState({
        popup: {
          type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
          meta: item,
          sensorData: sensorData,
        },
      });
    } else {
      API.sensorCode({
        storeId: storeId,
        stationId: stationId,
      })
        .then((resp) => {
          this.setState({
            sensorData: resp.data,
            popup: {
              type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
              meta: item,
              sensorData: resp.data,
            },
          });
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => this.handleErrorPopup(error));
    }
  };

  onResyncCheck = item => {
    this.getPopup('spinner', constants.syncingCheck, null);
    API.syncCheck({
      checkHeaderId: item.checkHeaderId,
    })
      .then(response => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  invokeTextToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const {
      phoneNumber,
      guestName,
      pickupTime,
      checkNumber,
      subTotal,
      tax,
      selectedCountry,
      preAuth,
    } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.textToPayGenLoader, null);
    API.generateTextToPay({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +subTotal,
      taxAmount: +tax,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
      preAuth: preAuth || false,
    })
      .then((response) => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeTextToPay(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  invokeCheckIn = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { phoneNumber, guestName, pickupTime, checkNumber, selectedCountry, } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.checkInRequestLoader, null);
    API.checkInRequest({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +0,
      taxAmount: +0,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
    })
      .then((response) => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeCheckIn(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  rePostPayment = ticket => {
    const { reduxProps, dispatchRetryPOS } = this.props;
    const { storeInfo, deviceApi } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const payload = {
      employeeId: null,
      storeId,
      deviceId,
      employeeCard: null,
      ticketId: ticket?.ticketId,
      checkTicketId: ticket?.id,
    };
    dispatchRetryPOS && dispatchRetryPOS(payload);
  };

  handleRetryPOSPayment = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    if (reduxProps.retryPOSPayment.timestamp !== prevReduxProps.retryPOSPayment.timestamp) {
      if (reduxProps.retryPOSPayment.data) {
        const popup = getPopupConfig('success');
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.error) {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = reduxProps.retryPOSPayment.error;
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = 'Posting Payment';
        this.setState({ popup });
      }
    }
  };

  onRedeemVoucher = (type, data) => {
    if (type === 'scanToRedeem' && window.ReactNativeWebView) {
      EventEmitter.scanQRCodeToRedeem('scanToRedeem');
    } else if (type === 'redeemCode') {
      const { first, last } = data || {};
      this.showRedeemConfirmation({
        voucherCodeTextFirst4: first,
        voucherCodeTextLast4: last,
      });
    } else if (type === 'managerOverride') {
      const { employeeCode } = data || {};
      this.showRedeemConfirmation({
        employeeCode: employeeCode,
      });
    }
  };

  onVoucherScanned = qrCode => {
    this.showRedeemConfirmation({
      voucherQrCode: qrCode,
    });
  };

  showRedeemConfirmation = payload => {
    const callback = () => {
      const { selectedCheck } = this.state;
      const { id: checkHeaderId } = selectedCheck || {};
      const { reduxProps: { storeInfo, deviceApi } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { deviceId } = deviceApi?.data;
      const newPayload = {
        ...payload,
        storeId,
        deviceId,
        checkHeaderId,
      };
      this.getPopup('spinner', 'Applying Voucher', null);
      API.voucherCheckIn(newPayload)
        .then(response => {
          this.state.popup = undefined;
          const newCheck = response.data;
          this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
          this.refreshChecks();
          const { context } = this.props;
          const { updateCheck } = context;
          updateCheck && updateCheck(response.data);
          FireboardUtils.addNetworkLogs(response);
        })
        .catch((error) => this.handleErrorPopup(error));
    };

    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will redeem the voucher and send any items to the kitchen. This action cannot be undone. Do you want to continue?';
    popup.buttons = [
      {
        text: 'No',
        onClick: () => this.setState({ popup: oldPopup })
      },
      {
        text: 'Yes',
        onClick: () => {
          callback && callback();
        },
      }
    ];
    this.setState({ popup });
  };

  generateQR = item => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR,
        meta: item,
      },
    });
  };

  onHandleTextToPay = (item, fromFooter) => {
    this.setState({ popup: { type: "textToPay", meta: item }, fromFooter });
  };

  textToCheckIn = (item, fromFooter) => {
    this.setState({ popup: { type: "checkIn", meta: item }, fromFooter });
  };

  openPaymentHistory = () => this.showPopup('repostpayment');

  onPressRedeemVoucher = () => this.showPopup('redeemCheckVoucher');

  onRequestRefreshGuestGPS = () => {
    const oldPopup = this.state.popup;

    const callback = () => {
      this.getPopup('spinner', 'Sending SMS to request guest location');
      const { checkHeaderId } = this.state?.selectedCheck || {};
      API.textToGetLocation(checkHeaderId)
        .then(response => {
          this.setState({ popup: oldPopup })
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will send a text message to the guest requesting their location. Do you want to continue?';
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: oldPopup }),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  onOrderDelivered = check => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = check || {};
    const payload = {
      storeId,
      checkHeaderId
    };
    this.getPopup('spinner', "Marking order as delivered");
    API.gpsLocationPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onSelectCheck = (check, callback) => {
    let items = check && check.items;
    let pendingItems = [];

    const { context } = this.props;
    const { acknowledgeCheck } = context;
    acknowledgeCheck && acknowledgeCheck(check?.checkHeaderId);

    const isPOSOrder = CommonUtil.getOrderTypeFromSourceType(check.sourceType) === constants.orderType_POS;
    if (isPOSOrder) {
      items = FireboardUtils.updatePOSItems(check);
      const pendingCheckItems = MenuUtils.getPendingItemsFromCheck(check);
      pendingItems = FireboardUtils.updatePendingPOSItems(pendingCheckItems, check);
    }

    this.filterOrdersWithSameTblNum(check);
    this.setState({ selectedCheck: check, items, pendingItems }, () => {
      callback && callback();
    });
  };

  filterOrdersWithSameTblNum = check => {
    if (this.currentMode === modeEnums.GPS_LOCATION)
      return;

    let checkIdsMap = new Map();
    const { orders } = check;
    const [order0] = orders || [];
    const { stationId } = order0 || {};
    if (stationId) {
      this.filteredChecks.forEach(eachCheck => {
        const { eachOrder0 } = eachCheck?.orders || [];
        const { eachStationId } = eachOrder0 || {};
        if (eachStationId === stationId)
          checkIdsMap.set(eachCheck.id, true);
      });
    }
    this.checkIdsMap = checkIdsMap;
  };

  onClickCheckFooterButton = (actionType, check) => {
    const callback = () => {
      switch (actionType) {
        case 'notify':
          this.showPopup('sms');
          break;
        case 'complete':
          this.updateOrderStatus(check, 'done');
          break;
        case 'delivered':
          this.onOrderDelivered(check);
          break;
        case 'viewOnMap':
          this.showPopup('viewOnMap');
          break;
        default:
          console.warn(`action type - ${actionType} is not handled!!!`);
          break;
      }
    }
    this.state.selectedCheck = check;
    this.onSelectCheck(check, callback);
  };

  onPressManageCubby = () => {
    const { selectedCheck } = this.state;
    const [order0] = selectedCheck?.orders || [];
    const { storeCubbySlotId } = order0 || {};
    if (!storeCubbySlotId) {
      this.cubbyLayoutPopupType = 'Assign';
      this.setState({ popup: { type: 'cubbyLayout' } });
    } else {
      this.setState({ popup: { type: 'cubbyMenu' } });
    }
  };

  onMoveSlotOrder = selectedSlots => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const slotIds = [...selectedSlots.keys()];
    const slotId = slotIds[0];
    const slots = [...selectedSlots.values()];
    const [slot0] = slots || []
    const slotName = slot0?.name || '';
    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId: slotId
    };
    const spinnerMsg = this.cubbyLayoutPopupType === 'Assign' ? 'Assigning slot' : 'Moving order';
    const toastMsg = this.cubbyLayoutPopupType === 'Assign' ? `Slot ${slotName} is assigned` : `Order is moved to slot ${slotName}`;
    this.callCubbyAssignApi(payload, spinnerMsg, toastMsg);
  };

  clearSlot = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId, orders } = this.state?.selectedCheck || {};
    const [order0] = orders || [];
    const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
    const slotName = slot?.name || '';

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId: null
      };
      this.callCubbyAssignApi(payload, 'Clearing slot', `Slot ${slotName} is cleared`);
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = `This will clear the order from slot ${slotName}. Do you want to continue?`;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  callCubbyAssignApi = (payload, spinnerMsg, toastMsg) => {
    this.getPopup('spinner', spinnerMsg);
    API.cubbyAssign(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        toast.success(toastMsg, { autoClose: 1000 });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  pickedUp = (counter) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      counter: counter || false,
    };
    this.getPopup('spinner', 'Marking order as picked up');
    API.orderPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onCubbyMenuPress = type => {
    switch (type) {
      case 'moveFromSlot':
        this.cubbyLayoutPopupType = 'Move';
        this.setState({ popup: { type: 'cubbyLayout' } });
        break;
      case 'clearFromSlot':
        this.clearSlot();
        break;
      case 'pickedUp':
        this.pickedUp(false);
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  showMemberDetailPopup = (memberId) => {
    this.getPopup("spinner", "Getting member details", null);
    API.getMemberDetails({ memberId })
      .then((res) => {
        this.setState({
          popup: {
            type: POPUPS_ENUMS.MEMBER_DETAILS,
            metaData: res.data,
          },
        });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  onPrintPress = (type, printMeta) => {
    const { selectedCheck } = this.state;
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const { id, checkHeaderId } = selectedCheck || {};
    let requestBody;
    let requestType;
    let printType;
    let spinnerMsg;
    if (type === 'check') {
      if (printMeta.display === 'GUEST RECEIPT') {
        if (selectedCheck && Object.keys(selectedCheck).length !== 0) {
          this.printCheck(selectedCheck);
          printType = 'Guest Receipt';
        }
        return;
      } else if (printMeta.display === 'FULL ORDER LABEL') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          includeItems: false,
        };
        requestType = 'printCheck';
        printType = 'Full Order Label';
      } else if (printMeta.display === 'ORDER + ITEMS LABELS') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          includeItems: true,
        };
        requestType = 'printCheck';
        printType = 'Order + Items';
      } else if (printMeta.display === 'INDIVIDUAL ITEM LABELS') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          checkItemIds: selectedCheck && selectedCheck.items.map(i => i.checkItemId),
        };
        requestType = 'printCheck';
        printType = 'Item Labels'
      } else if (printMeta.display === 'KITCHEN TICKET') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId,
        };
        requestType = 'printOrderTicket';
        printType = 'Kitchen Ticket';
      }
      spinnerMsg = `Printing ${printMeta.display}`;
    } else if (type === 'item') {
      requestBody = {
        storeId,
        deviceId,
        checkHeaderId: checkHeaderId || id,
        checkItemIds: [printMeta.checkItemId],
      };
      requestType = 'printItems';
      printType = 'Items';
      spinnerMsg = 'Printing item';
    }
    this.printCheckItems(type, printMeta, printType, requestType, requestBody, spinnerMsg);
  };

  printCheckItems = (type, printMeta, printType, requestType, requestBody, spinnerMsg) => {
    const { selectedCheck, items } = this.state;
    const { id: checkId, number: checkNumber, sourceType } = selectedCheck || {};
    this.getPopup('spinner', spinnerMsg, null);
    API[requestType](requestBody)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        console.info('response from print', response);
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = response.data.printerName
          ? `${constants.printLoading} at ${response.data.printerName}`
          : constants.printLoading;
        let updatedItems = [];
        const isPOSOrder =
          CommonUtil.getOrderTypeFromSourceType(sourceType) ===
          constants.orderType_POS;
        if (isPOSOrder) {
          if (type === 'item') {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => {
                  if (eachItem.id === printMeta.checkItemId) {
                    return {
                      ...eachItem,
                      printed: true,
                    };
                  }
                  return eachItem;
                });
              });
          } else {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => ({
                  ...eachItem,
                  printed: true,
                }));
              });
          }
        } else if (type === 'item') {
          updatedItems = items.map(eachItem => {
            if (eachItem.id === printMeta.checkItemId) {
              return {
                ...eachItem,
                printed: true,
              };
            }
            return eachItem;
          });
        } else {
          updatedItems = items.map(eachItem => ({
            ...eachItem,
            printed: true,
          }));
        }
        this.setState({ popup: printPopup, items: updatedItems });
        if (printType === 'Kitchen Ticket') {
          const { printJobs } = response.data;
          const printDataArray = Array.isArray(printJobs) ? printJobs : [];
          printDataArray.forEach(data =>
            this.printReceipt({
              type: 'print',
              data,
              printType,
            }, checkId, checkNumber)
          );
        } else {
          var data = {
            type: "print",
            data: response.data,
            printType,
          };
          this.printReceipt(data, checkId, checkNumber);
        }
        setTimeout(() => {
          this.closePopup();
        }, 4000);
      })
      .catch(error => {
        console.debug('error', error, error.response);
        this.handleErrorPopup(error);
      });
  };

  printReceipt = (data, checkId, checkNumber) => {
    const { printerIpAddress, printerName, printerPort } = data?.data || {};
    const logData = {
      checkId,
      checkNumber,
      printerName,
      printerIpAddress,
      printType: data?.printType,
    };
    UTILLib.printReceipt(
      data,
      () => this.closePopup(),
      error => {
        console.warn('error while printing receipt', error);
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = "Trying to connect to " + printerName + " with IP Address " + printerIpAddress + " and port " + printerPort + " " + error;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'FAILURE' });
      },
      () => {
        let popup = getPopupConfig('error', () => this.closePopup());
        popup.message = constants.extensionNotAvailable;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'SUCCESS' });
      },
    );
  };

  addPrintLog = logData => {
    const { checkId, checkNumber, printerName, printerIpAddress, status, printType } = logData || {};
    EventEmitter.addLogs(
      'appLogs',
      LogLevelEnum.INFO,
      `Print - ${moment(new Date).format('YYYY-MM-DD hh:mm:ss')} | Check Id - ${checkId} | Check Number - ${checkNumber} | Print Type - ${printType} | Printer Name - ${printerName} | Printer IP Address - ${printerIpAddress} | Print Status - ${status}`
    );
  };

  printCheck = (item) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, employee } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const { loginId } = employee || {}
    const { id } = item;
    const payload = {
      storeId,
      deviceId,
      employeeId: 0,
      checkHeaderId: id,
      seatIds: [],
      employeeCard: loginId || null,
    };
    this.getPopup('spinner', constants.printLoading, null);
    API.tableReceiptPrint(payload)
      .then(response => {
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = `${constants.printWithStation} ${response.data.printerName}`;
        this.setState({ popup: printPopup });
        var data = {
          type: "print",
          data: response.data,
        };
        const errorMsg = "Trying to connect to " + response.data.printerName + " with IP Address " + response.data.printerIpAddress + " and port " + response.data.printerPort + " ";
        UTILLib.printReceipt(
          data,
          () => this.closePopup(),
          error => this.getPopup('error', null, errorMsg + error),
          () => {
            let popup = getPopupConfig('error', () => this.closePopup());
            popup.message = constants.extensionNotAvailable;
            this.setState({ popup });
          },
        );
        setTimeout(() => {
          this.closePopup();
        }, 4000);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  onChangeSortBy = () => {
    this.setState(prevState => ({ sortByName: !prevState.sortByName }));
  };

  onChangeSorting = () => {
    this.setState(prevState => ({ ascending: !prevState.ascending }));
  };

  pad = (value) => {
    let str = String(value);
    let size = 10;
    while (size > 0) {
      str = '0' + str;
      size--;
    }
    return str;
  };

  sortChecksByTime = (a, b) => {
    const time1 = a.elapsedTimeInMS;
    const time2 = b.elapsedTimeInMS;
    return time1 - time2;
  };

  sortChecksByName = (a, b) => {
    const tblDeliveryName1 = this.pad(a.tblDeliveryName ? a.tblDeliveryName : '').toLowerCase();
    const tblDeliveryName2 = this.pad(b.tblDeliveryName ? b.tblDeliveryName : '').toLowerCase();
    if (tblDeliveryName1 < tblDeliveryName2)
      return -1;
    if (tblDeliveryName1 > tblDeliveryName2)
      return 1;
    return 0;
  };

  sortChecksByCheckNum = (a, b) => {
    const checkNum1 = this.pad(a.number ? a.number : '').toLowerCase();
    const checkNum2 = this.pad(b.number ? b.number : '').toLowerCase();
    if (checkNum1 < checkNum2)
      return -1;
    if (checkNum1 > checkNum2)
      return 1;
    return 0;
  };

  getCheckSortFunction = () => {
    const { sortByName } = this.state;
    let sortFunc = sortByName ? this.sortChecksByName : this.sortChecksByTime;
    if (this.currentMode === modeEnums.GPS_LOCATION)
      sortFunc = sortByName ? this.sortChecksByCheckNum : this.sortChecksByTime;
    return sortFunc;
  };

  onUpdateGuestInformation = guestInfo => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId } = selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      ...guestInfo,
    };
    this.getPopup('spinner', "Updating guest information");
    API.updateGuestInformation(payload)
      .then(response => {
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsSeeCounter = () => {
    this.pickedUp(true);
  };

  handleNewNotification = newNotifications => {
    const {
      dispatchUpdateNotification,
      context,
      reduxProps: { notifications },
    } = this.props;
    const { updateNotification } = context;

    newNotifications.forEach(res => {
      const { notificationControlEnabled } = this.state;
      const tempNotifications = [...notifications];
      let isNew = false;
      const notificationTimes = new Date().toISOString();
      let enabled = notificationControlEnabled;
      const activeNotificationFilter = this.activeCheckFilter;
      let nOrderTypes = this.getNotificationOrderTypes();

      if (
        res.new_val &&
        activeNotificationFilter !== null &&
        activeNotificationFilter !== undefined &&
        nOrderTypes > 0
      ) {
        const dataType = this.getOrderTypeValue(activeNotificationFilter, res.new_val);
        if (!nOrderTypes.includes(dataType)) {
          return;
        }
      }

      switch (res.type) {
        case "add":
        case "initial":
        case "update":
        case "change": {
          if (res.value.notificationTypeId === 16) {
            // this.setOrderTypeStatus(res.value);
          }
          const notificationIndex = tempNotifications.findIndex(notification =>
            notification.notificationId === res.value.notificationId
          );
          if (notificationIndex !== -1) {
            const updatedValue = {
              ...res.value,
              isNew: tempNotifications[notificationIndex].isNew || false,
              isDismissed:
                tempNotifications[notificationIndex].isDismissed || false,
              notificationTimes:
                tempNotifications[notificationIndex].notificationTimes ||
                notificationTimes,
            };
            tempNotifications.splice(notificationIndex, 1, updatedValue);
          } else {
            isNew = true;
            enabled = res.value.notificationTypeId !== NotificationType.SERVER_APP_PRINTER;
            clearInterval(this.snoozeTimeInterval);
            const updatedVal = {
              ...res.value,
              isNew,
              isDismissed: false,
              notificationTimes,
            };
            tempNotifications.push(updatedVal);
          }
          break;
        }
        default:
          console.info("notification type not handled", res.type);
      }

      this.state.notificationControlEnabled = enabled;
      this.state.snoozeEnabled = false;
      dispatchUpdateNotification(tempNotifications);
      updateNotification && updateNotification(res.value.notificationId);
    });
  };

  get notificationsData() {
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const sortedNotifications = this.sortNotifications(
      notificationsToBeDisplayed
    );
    const { managerMode } = this.state;
    const rowData =
      Array.isArray(sortedNotifications) &&
      sortedNotifications.length &&
      sortedNotifications.map((notification) => {
        return {
          sourceType:
            notification && notification.data && notification.data.sourceType,
          isNew: notification.isNew,
          time: this.getTime(notification),
          message: notification.note,
          ack: true,
          dismiss: true,
          goAndDismiss: true,
          notificationGoAndDismiss: this.notificationGoAndDismiss,
          dismissNotification: this.dismissNotification,
          ackNotification: this.ackNotification,
          goToCheck: this.goToCheck,
          notification: notification,
          managerMode,
        };
      });
    return rowData;
  };

  getNotificationsToBeDisplayed = () => {
    const { reduxProps } = this.props;
    const { managerMode, notificationTypes } = this.state;
    const { notifications } = reduxProps;
    let notificationsToBeDisplayed = notifications;
    const selectedNotifications = notificationTypes || [];
    const activeNotificationFilter = this.activeCheckFilter;
    if (managerMode) {
      return notifications.filter(n => n.notificationTypeId === 14 || n.notificationTypeId === 15);
    }
    if (selectedNotifications.length > 0) {
      const selectedIds = this.getSelectedNotificationTypeIds();
      notificationsToBeDisplayed = notifications.filter(
        notification => selectedIds.includes(notification.notificationTypeId) &&
          !notification.dismissed &&
          notification.notificationTypeId !== 15,
      );
      if (selectedIds.includes(9)) {
        const nOrderTypes = this.getNotificationOrderTypes();
        notificationsToBeDisplayed = notificationsToBeDisplayed.filter(r => {
          const sourceType = this.getOrderTypeValue(activeNotificationFilter, r);
          return (
            (nOrderTypes.length === 0 || nOrderTypes.includes(sourceType)) &&
            r.notificationTypeId !== NotificationType.SURVEY_POSTED &&
            r.notificationTypeId !== NotificationType.SERVER_APP_PRINTER &&
            !r.isDismissed
          );
        });
      }
    } else {
      notificationsToBeDisplayed = notifications.filter(
        n => !n.isDismissed && n.notificationTypeId !== 15,
      );
    }
    notificationsToBeDisplayed = notificationsToBeDisplayed.filter(n => n.enabled);
    return notificationsToBeDisplayed;
  };

  getSelectedNotificationTypeIds = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { notificationTypes = [] } = storeInfo.data || {};
    const { notificationTypes: selectedNotifications } = this.state;
    const nTypeIds = [];
    selectedNotifications.forEach(sn => {
      const n = notificationTypes.find(nt => nt.name === sn);
      if (n) nTypeIds.push(n.id);
    });

    /** These 3 notification type filter should always be enabled
     * ["MDM Policy Updated", "Device Notification", "Channel Status Update"]
     */
    const enabledNotificationIds = [16, 19, 20];
    return Array.from(new Set(nTypeIds.concat(enabledNotificationIds)));
  };

  sortNotifications = (notifications) => {
    const sortKey = "notificationId";
    return notifications.sort((n1, n2) => n2[sortKey] - n1[sortKey]);
  };

  getTime = (notification) =>
    notification.notificationTimes !== null &&
      notification.notificationTimes !== undefined
      ? FireboardUtils.getTimeInHrsMins(notification.notificationTimes)
      : "--";

  getNotificationOrderTypes = () => {
    let nOrderTypes = [];
    if (this.activeCheckFilter === 'sourceType') nOrderTypes = this.notificationSourceTypes;
    else if (this.activeCheckFilter === 'orderType') nOrderTypes = this.notificationOrderTypes;
    else if (this.activeCheckFilter === 'revenueCenter') nOrderTypes = this.notificationRevenueTypes;
    else if (this.activeCheckFilter === 'sensorGroup') nOrderTypes = this.notificationSensorGroupTypes;
    return nOrderTypes;
  };

  getOrderTypeValue = (type, response) => {
    let dataType = "";
    if (response.data) {
      if (type === "sourceType") {
        dataType = FireboardUtils.getNotificationSourceType(response.data.sourceType);
      } else if (type === "orderType") {
        const orderId = response.orderTypeId;
        dataType = this.getOrderTypeName(orderId);
      } else if (type === "revenueCenter") {
        const revenueId = response.revenueCenterId;
        dataType = this.getRevenueCenterName(revenueId);
      }
    }
    return dataType;
  };

  getOrderTypeName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const orderTypeDetails = storeInfo.data.orderTypes.find(each => each.id === id);
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  getRevenueCenterName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const revenueCenterDetails = storeInfo.data.revenueCenters.find(each => each.id === id);
    if (revenueCenterDetails) {
      return revenueCenterDetails.name;
    }
    return "";
  };

  notificationGoAndDismiss = (notification) => {
    const checkId = notification.data.checkHeaderId;
    const check = this.filteredChecks.find(ch => ch.id === checkId);
    if (!FireboardUtils.isObjectBlank(check)) {
      this.state.showNotifications = false;
      const formattedCheck = this.formatCheck(check);
      this.state.selectedCheck = formattedCheck;
      this.onSelectCheck(formattedCheck);
      this.ackNotification(notification);
    }
  };

  dismissNotification = (notification) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const notificationsCopy = notifications.slice();
    const notificationIndex = notificationsCopy.findIndex(
      (n) => n.notificationId === notification.notificationId
    );
    if (notificationIndex > -1) {
      notificationsCopy.splice(notificationIndex, 1, {
        ...notification,
        isDismissed: true,
      });
    }
    dispatchUpdateNotification(notificationsCopy);
  };

  ackNotification = (notification) => {
    const {
      reduxProps,
      dispatchAcknowledgeNotification,
      dispatchUpdateNotification,
    } = this.props;
    const { deviceApi, storeInfo } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id: storeId } = storeInfo?.data || {};
    if (notification.notificationTypeId === 16) {
      const { notifications } = reduxProps;
      const notificationsCopy = notifications.slice();
      const notificationIndex = notificationsCopy.findIndex(
        (n) => n.notificationId === notification.notificationId
      );
      if (notificationIndex !== -1) {
        notificationsCopy.splice(notificationIndex, 1, {
          ...notification,
          isDismissed: true,
        });
      }
      dispatchUpdateNotification(notificationsCopy);
    }
    const payload = {
      deviceId,
      storeId,
      notificationId: notification.notificationId,
    };
    dispatchAcknowledgeNotification(payload);
  };

  goToCheck = notification => {
    const checkId = notification.data.checkHeaderId;
    const check = this.filteredChecks.find(ch => ch.id === checkId);
    if (!FireboardUtils.isObjectBlank(check)) {
      this.state.showNotifications = false;
      const formattedCheck = this.formatCheck(check);
      this.state.selectedCheck = formattedCheck;
      this.onSelectCheck(formattedCheck);
    }
  };

  removeNewTag = (itemData) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const newNotifications = notifications.map((n) => {
      if (n.notificationId === itemData.id) {
        return { ...n, isNew: false };
      }
      return { ...n };
    });
    dispatchUpdateNotification(newNotifications);
  };

  setNotifications = () => {
    this.setState(prevState => ({
      ...prevState,
      showNotifications: !prevState.showNotifications,
      notificationControlEnabled: false,
      snoozeEnabled: false,
    }));
  };

  snoozeInterval = () => {
    clearInterval(this.snoozeTimeInterval);
    this.snoozeTimeInterval = setInterval(() => {
      this.setState({ snoozeEnabled: false });
    }, 1 * TimeConstants.MINUTE);
    this.setState({ snoozeEnabled: true });
  };

  onClickSms = seatId => {
    this.seatId = seatId;
    this.setState({ popup: { type: POPUPS_ENUMS.SMS } });
  };

  buildSensorsHashTable = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    this.sensorsMap = FireboardUtils.buildSensorsHashTable(sensors);
  };

  openCaptureSeatNamePopup = (seatId) => {
    this.seatId = seatId;
    this.setState({ popup: { type: 'captureSeatName' } });
  };

  onUpdateSeatName = (seatName) => {
    const { reduxProps: { storeInfo, login, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { id: employeeId } = login?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, } = selectedCheck || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      employeeCard: null,
      checkHeaderId,
      seatId: this.seatId,
      name: seatName,
    };
    this.seatId = null;
    this.getPopup('spinner', constants.updatingSeatName, null);
    API.renameSeat(payload)
      .then(response => {
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForCheck = () => {
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_CHECK }
      }
    });
  };

  invokeAgeRestrictedItemsForCheck = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { disableAgeRestricted } = order0 || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForCheck(payload)
      .then(response => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForSeat = (seatId, disableAgeRestricted) => {
    this.ageRestrictedItemsForSeat = { seatId, disableAgeRestricted };
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_SEAT }
      }
    });
  };

  invokeAgeRestrictedItemsForSeat = (employeeId) => {
    //if disableAgeRestricted is true - send false to endpoint
    //if disableAgeRestricted is false - send true to endpoint
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId } = selectedCheck || {};
    const { seatId, disableAgeRestricted } = this.ageRestrictedItemsForSeat || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      seatId: seatId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForSeat(payload)
      .then(response => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  sendPendingItems = () => {
    const { pendingItems, selectedCheck } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, login, deviceApi, deviceApiData } = reduxProps;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { id: employeeId } = login?.data || {};
    if (pendingItems) {
      const checkValues = Object.values(pendingItems);
      if (checkValues && checkValues.length > 0) {
        checkValues.forEach(eachSeat => {
          if (eachSeat && eachSeat.length > 0) {
            this.getPopup("spinner", constants.sendPendingItems, null);
            let allItems = [];
            eachSeat.forEach(eachItem => {
              allItems.push({
                checkOrderItemId: eachItem.id,
                orderSendMode: eachItem.orderSendMode,
              });
            });

            const request = {
              storeId: storeInfo.data.id,
              employeeId: employeeId || null,
              deviceId: deviceId,
              checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
              employeeCard: null,
              items: allItems,
            }
            API.firePendingItems(request)
              .then((res) => {
                this.closePopup();
                FireboardUtils.addNetworkLogs(res);
              })
              .catch((error) => this.handleErrorPopup(error));
          }
        })
      }
    }
  };

  onLogin = (loginId, indentifier) => {
    const { reduxProps: { deviceApi, deviceApiData } } = this.props;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const payload = {
      deviceId: deviceId,
      appVersion: version,
      employeeCode: loginId,
      employeeCard: null,
      jobId: null,
      manager: false,
    };
    this.getPopup('spinner', constants.loginLoadingHeading, null);
    API.login(payload, true)
      .then(response => {
        const { id: employeeId } = response.data;
        if (indentifier === checkEnum.ID_CHECK) {
          this.onMarkAsAgeVerified(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_CHECK) {
          this.invokeAgeRestrictedItemsForCheck(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_SEAT) {
          this.invokeAgeRestrictedItemsForSeat(employeeId);
        } else {
          this.setState({ popup: undefined });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsAgeVerified = () => {
    this.setState({ popup: { type: 'login', metaData: { indentifier: checkEnum.ID_CHECK } } });
  };

  onMarkAsAgeVerified = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { ageVerificationStatus } = order0 || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      checkHeaderId,
      confirmIdCheck: ageVerificationStatus === 5 ? false : true,
    };
    const spinnerMsg = ageVerificationStatus === 5 ? constants.clearingIdCheck : constants.confirmingIdCheck;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageVerification(payload)
      .then(response => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        const { context } = this.props;
        const { updateCheck } = context;
        updateCheck && updateCheck(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  get viewProps() {
    const {
      popup,
      isCustomSmsType,
      customSmsList,
      selectedCheck,
      isDevEnvironment,
      fromFooter,
      checkList,
      items,
      pendingItems,
      twoDimensionSlot,
      sortByName,
      ascending,
      showNotifications,
      snoozeEnabled,
      notificationControlEnabled,
    } = this.state;
    const { reduxProps: { storeInfo, currencyInfo, deviceApi, deviceApiData } } = this.props || {};
    const { iso2 } = currencyInfo || {};
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    const checkFilters = {
      orderType: 'All',
      activeCheckFilter: this.activeCheckFilter,
      checkSourceTypes: this.checkSourceTypes,
      checkOrderTypes: this.checkOrderTypes,
      checkRevenueTypes: this.checkRevenueTypes,
      checkSensorGroupTypes: this.checkSensorGroupTypes,
    };
    const checkSortFunction = this.getCheckSortFunction();
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const newNotificationCount = Array.isArray(notificationsToBeDisplayed)
      ? notificationsToBeDisplayed.filter(n => n.isNew).length
      : 0;
    const totalNotificationsCount = Array.isArray(notificationsToBeDisplayed)
      ? notificationsToBeDisplayed.filter(n => n).length
      : 0;

    return {
      popup,
      parentRoute: this.parentRoute,
      checkList,
      items,
      pendingItems,
      iso2,
      currency: this.currency,
      isCustomSmsType,
      customSmsList,
      storeInfo: storeInfo.data,
      selectedCheck,
      isDevEnvironment,
      notifyOrderPrepared: this.notifyOrderPrepared,
      notifyOrderReady: this.notifyOrderReady,
      fromFooter,
      deviceGroup,
      currentMode: this.currentMode,
      checkFilters,
      twoDimensionSlot,
      cubbyLayoutPopupType: this.cubbyLayoutPopupType,
      sortByName,
      ascending,
      checkIdsMap: this.checkIdsMap,
      showNotifications,
      snoozeEnabled,
      notificationControlEnabled,
      notificationCount: newNotificationCount,
      totalNotificationsCount,
      notificationsData: this.notificationsData,
      sensorsMap: this.sensorsMap,
      enableAgeRestrictedOrderingForCheck: this.enableAgeRestrictedOrderingForCheck,
      enableAgeRestrictedOrderingForSeat: this.enableAgeRestrictedOrderingForSeat,
      enableAgeVerification: this.enableAgeVerification,
      checkSortFunction,
      closePopup: this.closePopup,
      showPopup: this.showPopup,
      goBack: this.goBack,
      onChangeSmsType: this.onChangeSmsType,
      onHandleSend: this.onHandleSend,
      updateOrderStatus: this.updateOrderStatus,
      onHandleTextToPay: this.onHandleTextToPay,
      textToCheckIn: this.textToCheckIn,
      notifyOrderStatus: this.notifyOrderStatus,
      onResyncCheck: this.onResyncCheck,
      joinCheck: this.joinCheck,
      markItemAsPaid: this.markItemAsPaid,
      invokeTextToPay: this.invokeTextToPay,
      invokeCheckIn: this.invokeCheckIn,
      onQRGenerate: this.generateQR,
      openPaymentHistory: this.openPaymentHistory,
      rePostPayment: this.rePostPayment,
      onPressRedeemVoucher: this.onPressRedeemVoucher,
      onRedeemVoucher: this.onRedeemVoucher,
      onRequestRefreshGuestGPS: this.onRequestRefreshGuestGPS,
      onOrderDelivered: this.onOrderDelivered,
      onSelectCheck: this.onSelectCheck,
      onClickCheckFooterButton: this.onClickCheckFooterButton,
      showMemberDetailPopup: this.showMemberDetailPopup,
      onPrintPress: this.onPrintPress,
      onCubbyMenuPress: this.onCubbyMenuPress,
      onMoveSlotOrder: this.onMoveSlotOrder,
      onPressManageCubby: this.onPressManageCubby,
      onChangeSortBy: this.onChangeSortBy,
      onChangeSorting: this.onChangeSorting,
      onUpdateGuestInformation: this.onUpdateGuestInformation,
      markAsSeeCounter: this.markAsSeeCounter,
      setNotifications: this.setNotifications,
      snoozeNotifications: this.snoozeInterval,
      removeNewTag: this.removeNewTag,
      onClickSms: this.onClickSms,
      openCaptureSeatNamePopup: this.openCaptureSeatNamePopup,
      onUpdateSeatName: this.onUpdateSeatName,
      onUpdateAgeRestrictedItemsForCheck: this.onUpdateAgeRestrictedItemsForCheck,
      onUpdateAgeRestrictedItemsForSeat: this.onUpdateAgeRestrictedItemsForSeat,
      sendPendingItems: this.sendPendingItems,
      markAsAgeVerified: this.markAsAgeVerified,
      onLogin: this.onLogin,
    };
  };

  render() {
    const viewProps = this.viewProps;
    return (
      <View {...viewProps} />
    );
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchRetryPOS: (payload) => {
    dispatch(retryPOSPayment(payload));
  },
  dispatchUpdateNotification: (payload) => {
    dispatch(updateNotification(payload));
  },
  dispatchAcknowledgeNotification: (payload) => {
    dispatch(acknowledgeNoticationAction(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(TableDelivery));
